import { Container as ContainerBootstrap } from "react-bootstrap";
import { useTranslation } from 'next-i18next';
import styled, { css } from "styled-components";

const Container = styled(ContainerBootstrap)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 40px;
`;

const PaginatorText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  margin: 0;
  margin-right: 16px;
  color: ${({ theme }) => theme.colors['neutral-05']};
  

  & span {
    border: 1px ${({ theme }) => theme.colors['neutral-03']} solid;
    border-radius: 100px;
    width: 56px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors['neutral-05']};
    
    margin-inline: 8px;
  }

  :is([data-theme="dark"] &) {
    color: ${({ theme }) => theme.colors['neutral-01']};

    & span {
      color: ${({ theme }) => theme.colors['neutral-01']};
    }
  }
`;

const ArrowButton = styled.button`
  border: none;
  cursor: pointer;
  padding: 0;
  height: 24px;
  width: 24px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-07']};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors['neutral-07']};
  
  path {
    color: ${({ theme }) => theme.colors['neutral-01']};
  }

  &.arrow-left svg {
    margin-right: 10px;
    transform: translateX(50%);
  }

  &.arrow-right svg {
    margin-left: 9px;
    transform: translateX(-50%);
  }

  ${({ disabled, theme }) => disabled && css`
    border-color: ${theme.colors['neutral-04']};
    background-color: ${theme.colors['neutral-01']};

    &:hover {
      cursor: not-allowed;
    }

    path {
      color: ${theme.colors['neutral-04']};
    }
  `}

  :is([data-theme="dark"] &) {
    background-color: ${({ theme }) => theme.colors['neutral-01']};
    border-color: ${({ theme }) => theme.colors['neutral-01']};

    path {
      color: ${({ theme }) => theme.colors['neutral-04']};
    }

    ${({ disabled, theme }) => disabled && css`
      border-color: ${theme.colors['neutral-03']};
      background-color: ${theme.colors['background-02']};

      path {
        color: ${theme.colors['neutral-04']};
      }
    `}
  }
`;

const ArrowContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;


export function Paginator({ page, totalPages, onNext, onPrev }) {
  const { t } = useTranslation();
  return (
    <Container>
      <PaginatorText>
        {t("blog.page")} <span>{page}</span> {t("blog.of")}{' '}{totalPages}
      </PaginatorText>

      <ArrowContainer>
        <ArrowButton
          className="arrow-left"
          disabled={page === 1}
          onClick={onPrev}
        >
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 10.6668L1.33333 6.00016L6 1.3335" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </ArrowButton>

        <ArrowButton
          className="arrow-right"
          disabled={page >= totalPages}
          onClick={onNext}
        >
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.33317L5.66667 5.99984L1 10.6665" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </ArrowButton>
      </ArrowContainer>
    </Container>
  )
};
